import Carousel from 'react-material-ui-carousel';
import { ReactNode } from 'react';

type ResourcesCarouselProps = {
  children?: ReactNode;
};

export const ResourcesCarousel = (props: ResourcesCarouselProps) => {
  return (
    <Carousel
      sx={{
        pt: 10,
        borderRadius: 5,
        cursor: 'pointer',
      }}
      activeIndicatorIconButtonProps={{
        style: {
          backgroundColor: 'white',
          width: 10,
          height: 10,
        },
      }}
      indicatorIconButtonProps={{
        style: {
          color: 'transparent',
          border: '1px solid white',
          width: 10,
          height: 10,
          margin: '0px 4px',
        },
      }}
      indicatorContainerProps={{
        style: {
          position: 'absolute',
          bottom: 0,
          zIndex: 1,
        },
      }}
      navButtonsWrapperProps={{
        style: {
          paddingTop: 50,
        },
      }}
      navButtonsProps={{
        style: {
          backgroundColor: 'white',
          color: 'black',
          opacity: 1,
        },
      }}
    >
      {props.children}
    </Carousel>
  );
};
